export const API_URL =
    process.env.REACT_APP_API_URL || 'https://mall-backend-render.onrender.com/api';